<template>
    <b-nav-item-dropdown
        class="help-menu"
        id="topo-ajuda"
        right
        ref="navdropdown"
    >
        <template #button-content>
            <i class="fa fa-question-circle"></i>
        </template>
        <li 
            class="header"
        >
            Ajuda
        </li>
        <li>
            <ul class="menu">
                <li 
                    v-for="topico in topicos" 
                    :key="topico.nome"
                >
                    <a 
                        :href="topico.link" 
                        :target="topico.target"
                        @click="$refs.navdropdown.hide()"
                    >
                        <h3>
                            <div>
                                <i :class="topico.icone"></i> 
                                {{ topico.nome }}
                            </div>
                            <span 
                                class = "text-muted"
                            >
                                {{ topico.descricao }}
                            </span>
                        </h3>
                    </a>
                </li>
            </ul>
        </li>
    </b-nav-item-dropdown>
</template>
<script>
export default {
    data(){
        return {
            topicos: [
                {
                    nome: 'Aplicativo Desktop', 
                    icone: 'fa icon-font icon-battery', 
                    descricao: 'Aplicativo para emissão de notas com certificado A3', 
                    link: '/desktop/' + this.$app.aplicativo_desktop,
                    target: '_blank'
                },
                {
                    nome: 'Suporte remoto', 
                    icone: 'fa icon-sync', 
                    descricao: 'Acessamos seu computador pela Internet', 
                    link: '',
                    target: '_blank'
                }
            ]
        }
    }
}
</script>